import React from "react";

import Styles from "./Terms.styles";
import { TermsProps as Props } from "./Terms.types";
import Navbar from "components/global/Navbar/Navbar";
import Footer from "components/global/Footer/Footer";
import GoBack from "components/global/GoBack/GoBack";

const Terms: React.FC<Props> = props => {
  return (
    <Styles className="Terms">
      <header className="Terms__header">
        <Navbar showBrand />
        <GoBack title="Atrás" className="Terms__back" />
      </header>
      <main className="Terms__main">
        <section className="Terms__content">
          <h1 className="Terms__title">Términos y condiciones</h1>
          <div className="Terms__details">
            <p className="Terms__paragraph">
              El uso del sitio web y la aplicación móvil en los que estos
              términos residen (colectivamente, la “Plataforma”), y las
              características de esta plataforma están sujetos a estas
              Condiciones de Uso (este “Acuerdo”), que establece un acuerdo
              legalmente vinculante entre usted, EL HORNERO y LAS EMPRESAS QUE
              DISTRIBUYEN LOS PRODUCTOS DE LA MARCA. Por favor, lea este Acuerdo
              cuidadosamente antes de utilizar esta Plataforma. Si no está de
              acuerdo con los términos contenidos en este Acuerdo, entonces no
              utilice la Plataforma. El uso de la Plataforma constituye el
              reconocimiento de su aceptación de este Acuerdo. Esto incluye,
              pero no se limita a, la realización de una transacción electrónica
              y la aceptación de la renuncia de garantías, indemnizaciones y
              recursos exclusiones y limitaciones. Usted reconoce que ha leído y
              acepta estar obligado por este Acuerdo a cumplir con todas las
              leyes, reglamentos y / o normas aplicables en relación con el uso
              de la Plataforma.
            </p>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO puede actualizar esta plataforma y el presente
              Acuerdo cada cierto tiempo. El uso de esta plataforma después de
              que LA MARCA EL HORNERO notifica una actualización de la
              plataforma o de este Acuerdo constituye la aceptación de dichos
              cambios de forma prospectiva desde la fecha de dichos cambios. LA
              MARCA EL HORNERO puede, a su sola discreción y en cualquier
              momento, suspender esta Plataforma o cualquier parte de la misma,
              con o sin previo aviso, o impedir su uso con o sin previo aviso.
              Usted está de acuerdo que no tiene ningún derecho en esta
              Plataforma y LA MARCA EL HORNERO no tendrá ninguna responsabilidad
              con usted si se interrumpe esta Plataforma o si su capacidad de
              acceder a la plataforma termina.
            </p>
            <p className="Terms__paragraph">
              No puede utilizar la Plataforma para finalidades ilegales o
              prohibidas por este acuerdo. Su acceso a la Plataforma puede ser
              terminado inmediatamente a discreción única de LA MARCA EL HORNERO
              O DE CUALQUIERA DE LAS EMPRESAS QUE DISTRIBUYEN LA MARCA EL
              HORNERO, con o sin aviso, si usted no cumple con alguna
              disposición de este acuerdo y/o condiciones adicionales.
            </p>
            <h2 className="Terms__subtitle">LICENCIA</h2>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO le concede una licencia limitada, no exclusiva
              y revocable para utilizar partes de la Plataforma únicamente para
              sus propios fines privados, no comerciales solamente y
              exclusivamente de acuerdo con los términos de este Acuerdo. Usted
              reconoce que cualquier dependencia de la Plataforma o de cualquier
              Contenido (como se define más adelante) será bajo su propio
              riesgo. EL HORNERO tampoco hace ninguna representación con
              respecto a la cantidad de tiempo que se conservará cualquier
              contenido. La Plataforma, y cualquiera de los servicios
              realizados, proporcionados o habilitados a través de la Plataforma
              y toda la información, las comunicaciones, fotos, texto, vídeo,
              gráficas, música, sonidos, imágenes, diseño y otros materiales
              proporcionados a usted a través de la Plataforma y la compilación
              de lo anterior (en conjunto, “contenido”), sólo están previstos
              para el uso lícito por parte de los usuarios de la Plataforma. La
              Plataforma, contenido, y la selección, coordinación y disposición
              de los mismos, son propiedad de LA MARCA EL HORNERO, y / o sus
              respectivos licenciantes. La copia no autorizada, muestra, venta,
              distribución o cualquier otro uso de cualquier contenido o
              plataforma es una violación de la ley. Usted reconoce haber sido
              avisado por LA MARCA EL HORNERO que el Contenido y la Plataforma
              están protegidos en Ecuador e internacionalmente por una variedad
              de leyes, incluyendo pero no limitado a, las leyes de derechos de
              autor y los tratados internacionales, leyes de marcas registradas,
              las leyes de patentes y propiedad intelectual y otras leyes de
              propiedad exclusiva y de derechos. Usted manifiesta y garantiza
              que utilizará la Plataforma y el Contenido sólo para los fines
              permitidos en el presente documento, que toda la información que
              presente es precisa y por lo demás cumple con este Acuerdo, y que
              va a notificar de inmediato a LA MARCA EL HORNERO O A CUALQUIERA
              DE LAS EMPRESAS AUTORIZADAS QUE DISTRIBUYEN LA MARCA si alguna
              información cambia. LA MARCA EL HORNERO no garantiza que la
              Plataforma o el Contenido sean apropiados o estén disponibles para
              su uso en determinadas localidades.
            </p>
            <p className="Terms__paragraph">
              La Plataforma, Contenido, las Actualizaciones de la Plataforma
              (como se define más adelante), documentación, y cualquier tipo de
              letra que se acompañan, sea en memoria de solo lectura, en
              cualquier otro soporte o de cualquier otra forma han sido
              autorizados a usted por LA MARCA EL HORNERO sujetos a los términos
              de este Acuerdo. Los derechos otorgados en este documento no son
              transferibles, y se limitan a los derechos de propiedad
              intelectual de LA MARCA EL HORNERO de la Plataforma y no incluyen
              ninguna otra patente o derechos de propiedad intelectual. El
              presente Contrato le concede permiso para utilizar la Plataforma
              en un dispositivo a la vez. El usuario no puede hacer que la
              Plataforma esté disponible en una red en la que se podría utilizar
              en varios dispositivos al mismo tiempo. Este Acuerdo no le concede
              ningún derecho a utilizar las interfaces u otra propiedad
              intelectual en diseño, desarrollo, fabricación, concesión de
              licencias, o la distribución de dispositivos de terceros y
              accesorios para su uso con la Plataforma. Cualquier uso de la
              Plataforma de cualquier forma no permitida en virtud del presente
              Acuerdo, incluyendo, sin limitación, la reventa, transferencia,
              modificación o distribución de la Plataforma, la copia o
              distribución de texto, imágenes, música, vídeo, datos,
              hipervínculos, pantallas, y otros contenidos proporcionados por la
              Plataforma está prohibido. Este Acuerdo no le da derecho a recibir
              y no obliga a LA MARCA EL HORNERO O A LAS EMPRESAS QUE DISTRIBUYEN
              LA MARCA para proporcionar documentación impresa, apoyo,
              asistencia telefónica, o mejoras o cambios a la Plataforma. Usted
              no puede modificar, alterar, copiar, mostrar públicamente o
              ejecutar, distribuir, crear trabajos derivados, de la Plataforma.
            </p>
            <p className="Terms__paragraph">
              Usted se compromete a no descargar, exhibir o usar cualquier
              contenido en cualquier publicación, espectáculos públicos, en
              sitios web para cualquier otro fin comercial, en relación con los
              productos o servicios que no sean los de LA MARCA EL HORNERO, en
              cualquier otra forma que pueda causar confusión entre los
              consumidores, que diluye la fuerza de LA MARCA EL HORNERO o sus
              licenciatarios, o que infrinja los derechos de propiedad
              intelectual de LA MARCA EL HORNERO. Asimismo, acepta que no dará
              ningún uso indebido de cualquier Contenido de la Plataforma.
            </p>
            <h2 className="Terms__subtitle">USO DE LA PLATAFORMA</h2>
            <p className="Terms__paragraph">
              Los siguientes requisitos se aplican al uso de la Plataforma:
            </p>
            <ul className="Terms__list">
              <li className="Terms__list__item">
                No utilizará ninguna característica de comunicación electrónica
                de la Plataforma para cualquier propósito que sea ilegal,
                dañino, tortuoso, difamatorio, calumnioso, obsceno, invasivo de
                la privacidad de otra persona, amenazante, abusivo, odioso,
                racista, ilegal, pornográfico, que incite a actos criminales o
                abusivos, o para propósitos censurables o inapropiados según lo
                determinado por LA MARCA EL HORNERO.
              </li>
              <li className="Terms__list__item">
                Usted no va a cargar, publicar, reproducir o distribuir
                cualquier información, software u otro material protegido por
                derechos de autor o cualquier otro derecho de propiedad
                intelectual (así como los derechos de publicidad y privacidad)
                sin obtener primero el permiso del propietario de tales
                derechos.
              </li>
              <li className="Terms__list__item">
                Usted no va a recoger o almacenar datos personales de otros
                usuarios.
              </li>
              <li className="Terms__list__item">
                No utilizará la Plataforma para fines comerciales sin la
                autorización expresa por escrito de LA MARCA EL HORNERO.
              </li>
              <li className="Terms__list__item">
                Usted no va a cargar, enviar por correo electrónico, incluir en
                los mensajes (como se define más adelante) o transmitir
                cualquier material que contenga virus, archivos corruptos,
                software, enlaces a otros sitios o cualquier otro código
                informático, archivos o programas que puedan afectar
                adversamente, interrumpir, limitar o interferir con el
                funcionamiento del sistema de LA MARCA EL HORNERO o la
                computadora de cualquier tercero. Asimismo, acepta que usted no
                va a compartir o publicar cualquier contenido que atente contra
                el funcionamiento de la plataforma u otra característica.
              </li>
            </ul>
            <h2 className="Terms__subtitle">CONTENIDO GENERADO POR USUARIOS</h2>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO O LAS EMPRESAS QUE DISTRIBUYEN LA MARCA, se
              reserva el derecho de monitorear cualquier y todos los mensajes,
              anuncios, u otros contenidos enviados a la Plataforma, y nos
              reservamos el derecho de eliminar o negarse a publicar cualquier
              cosa que LA MARCA EL HORNERO O A LAS EMPRESAS QUE DISTRIBUYEN LA
              MARCA, a su sola discreción, considere que las Normas de
              Publicación, la ley, o sea inadecuada por otro motivo. Sin
              embargo, LA MARCA EL HORNERO no necesariamente, supervisa el
              material publicado, transmitido, o comunicados dentro de la
              Plataforma.
            </p>
            <p className="Terms__paragraph">
              No contenido ilegal o abusivo: Usted entiende y acepta que es
              responsable del contenido de sus mensajes, y se compromete a no
              incluir nada que sea ilegal, dañino, tortuoso, difamatorio,
              calumnioso, obsceno, invasivo de la privacidad de otra persona,
              amenazante, abusivo, odioso, racista, ilegal, pornográfico, incita
              a actos criminales o abusivos, o sea dudoso o inapropiado según lo
              determinado por LA MARCA EL HORNERO.
            </p>
            <p className="Terms__paragraph">
              No Violaciones de Derechos de terceros: Usted acepta que no
              publicará en sus mensajes algún contenido que contiene información
              personal acerca de cualquier individuo, viola la privacidad de
              cualquier otra persona o entidad, o cualquier cosa que usted está
              bajo la obligación contractual de mantener en privado o
              confidencial. Usted acepta que no se hará pasar por cualquier
              persona u organización, incluyendo, sin limitación, el personal de
              LA MARCA EL HORNERO. Asimismo, acepta que no falsificará una
              afiliación con otra persona u organización, ni va a publicar
              ningún contenido que contenga comentarios calumniosos o
              difamatorios sobre otros, o que infrinja los derechos de autor,
              marcas, patentes, secretos comerciales u otros derechos de
              propiedad intelectual de un tercero (así como los derechos de
              publicidad y privacidad). Usted acepta que no recogerá o
              almacenará datos personales de otros usuarios.
            </p>
            <p className="Terms__paragraph">
              Si usted cree que un mensaje fue publicado en violación de este
              acuerdo, por favor, copie el texto del mensaje en un correo
              electrónico y envíe a clientes@pizzeriaelhornero.com.ec. El
              usuario acepta que LA MARCA EL HORNERO no puede actuar como
              árbitro de los conflictos derivados de las comunicaciones de
              terceros o de la transmisión a la plataforma. Para obtener más
              información sobre la presentación de quejas, por favor, póngase en
              contacto con clientes@elhornero.com.ec. Sin limitar los derechos o
              recursos de LA MARCA EL HORNERO, las violaciones de cualquiera de
              las reglas anteriores pueden dar lugar a una notificación de
              advertencia, la eliminación de contenido ofensivo o terminación de
              su cuenta.
            </p>
            <p className="Terms__paragraph">
              Si usted es propietario de un derecho de autor o marca comercial y
              cree que se han violado sus derechos, por favor, póngase en
              contacto con clientes@elhornero.com.ec.
            </p>
            <h2 className="Terms__subtitle">COMUNICACIÓN CON EL HORNERO</h2>
            <p className="Terms__paragraph">
              En ciertas áreas de la Plataforma se le puede dar la capacidad de
              ponerse en contacto con EL HORNERO por correo electrónico, por
              ejemplo, para inscribirse en servicios tales como notificaciones
              de correo electrónico y boletines de noticias acerca de los
              productos de EL HORNERO, para inscribirse en un sorteo o concurso
              en particular. La información que proporcione a EL HORNERO a
              través de la Plataforma se rige por la Política de Privacidad de
              EL HORNERO.
            </p>
            <p className="Terms__paragraph">
              Mediante el uso de la Plataforma, usted reconoce y acepta que
              cualquier material, ideas u otras comunicaciones que usted
              transmita a EL HORNERO en cualquier forma y por cualquier motivo,
              no será tratada como confidencial o privada. Además, usted
              reconoce y acepta que cualquier idea, conceptos, técnicas,
              procedimientos, métodos, sistemas, diseños, gráficos, u otros
              materiales que usted transmita a EL HORNERO pueden ser utilizados
              por EL HORNERO en cualquier lugar, en cualquier momento y por
              cualquier motivo.
            </p>
            <h2 className="Terms__subtitle">SERVICIO MÓVIL E INTERNET</h2>
            <p className="Terms__paragraph">
              El uso de la Plataforma en un dispositivo móvil (sea la plataforma
              de aplicación móvil o plataforma web móvil) requiere el uso de un
              dispositivo móvil y el servicio móvil de datos inalámbrico, que
              debe ser obtenida de su proveedor de servicios inalámbricos, y
              pueden requerir acceso a Internet, que debe ser obtenido a partir
              de su proveedor de servicios. Usted es responsable de obtener y
              pagar por estos servicios adicionales y la obtención de un
              dispositivo adecuado, incluyendo, sin limitación, todos los cargos
              de uso relacionados con el mismo. La Plataforma puede solicitarle
              enviar y recibir, a su costo, las comunicaciones electrónicas
              relacionadas con la misma, incluyendo, sin limitación, mensajes
              administrativos, anuncios de servicio, informes de datos de
              diagnóstico, y las actualizaciones de plataforma, de EL HORNERO,
              su operador de telefonía móvil o terceros proveedores de servicios
              . Si usted no tiene un plan de datos móviles de telefonía celular
              ilimitado, puede incurrir en cargos adicionales de su proveedor de
              servicios inalámbricos en relación con el uso de la Plataforma.
              Usted es el único responsable de obtener los servicios de
              suscripción, de conectividad adicionales o equipos necesarios para
              acceder a la Plataforma, incluyendo pero no limitado al pago de
              todas las cuotas de terceros asociados a los mismos.
            </p>
            <p className="Terms__paragraph">
              La Plataforma puede no funcionar con todos los ordenadores,
              navegadores, dispositivos o todos los operadores de telefonía
              móvil. LA MARCA EL HORNERO no hace ninguna declaración de que la
              plataforma será compatible con todos los ordenadores, navegadores,
              dispositivos o compañías de telefonía móvil.
            </p>
            <p className="Terms__paragraph">
              Parte de la funcionalidad de la Plataforma, incluyendo el pago
              móvil, los servicios basados en la localización y funcionalidad, y
              el acceso de la libreta de direcciones del usuario y la biblioteca
              de fotos puede requerir la transmisión de la información
              proporcionada por el usuario, incluyendo, sin limitación, nombres,
              nombres de usuario y contraseñas, direcciones, dirección, fotos,
              información financiera (como números de tarjetas de crédito)
              e-mail y / o localización GPS. Si el usuario utiliza la
              funcionalidad de dicha Plataforma, el usuario consiente la
              transmisión de la información del usuario a LA MARCA EL HORNERO y
              / o sus agentes y autoriza a LA MARCA EL HORNERO y / o sus agentes
              para registrar, procesar y almacenar la información del usuario
              como sea necesario para la funcionalidad de la Plataforma y para
              los propósitos descritos en la Política de Privacidad de LA MARCA
              EL HORNERO.
            </p>
            <h2 className="Terms__subtitle">
              CUENTAS, CONTRASEÑAS Y SEGURIDAD
            </h2>
            <p className="Terms__paragraph">
              Ciertas áreas de la Plataforma pueden requerir registro o de lo
              contrario pueden pedir, proporcionar información para participar
              en ciertas funciones o acceder a determinados contenidos. Si
              decide no proporcionar dicha información, es posible que no pueda
              acceder a determinados contenidos o participar en ciertas
              características de la Plataforma o cualquier característica en
              absoluto.
            </p>
            <p className="Terms__paragraph">
              Usted entiende que ciertas ofertas, servicios y características
              que pueden estar disponibles en la Plataforma pueden estar sujetos
              a términos y condiciones específicas adicionales. Esto puede
              incluir programas de lealtad y recompensas. En el caso de
              cualquier conflicto entre este Acuerdo y cualquiera de dichos
              términos y condiciones específicos, los términos y condiciones
              específicos controlarán. También entiende y acepta que
              determinadas ofertas, servicios y funciones pueden estar
              disponibles en la versión página web de la Plataforma y no en la
              versión aplicación móvil de la Plataforma, y viceversa.
            </p>
            <p className="Terms__paragraph">
              Si la Plataforma requiere la creación de una cuenta o de lo
              contrario enviar información, debe completar el proceso
              especificado proporcionando a LA MARCA EL HORNERO con la
              información actual, completa y exacta a lo solicitado en el
              formulario de registro correspondiente. Es su responsabilidad
              mantener la integridad y exactitud de los datos actuales de
              registro, y cualquier pérdida causada por el hecho de no hacerlo
              es su responsabilidad. Durante el proceso de registro, se le
              pedirá que introduzca su nombre y dirección de correo electrónico
              válida y elegir una contraseña. Es el único responsable de
              mantener la confidencialidad de su contraseña y cuenta. Además,
              usted es el único responsable de cualquiera y todas las
              actividades que ocurran bajo su cuenta, incluidos los pagos
              móviles, todas las transacciones y otras actividades llevadas a
              cabo con el dispositivo, o tarjeta de pago almacenada, ya sea o no
              autorizado. Usted se compromete a notificar a LA MARCA EL HORNERO
              inmediatamente de cualquier uso no autorizado de su cuenta.
              Además, acepta no enviar por correo electrónico, publicar o
              difundir cualquier ID de usuario, contraseña u otra información
              que le proporciona acceso a la Plataforma. LA MARCA EL HORNERO no
              se hace responsable de cualquier pérdida que pueda sufrir como
              resultado de que otra persona utilice su contraseña o cuenta, ya
              sea con o sin su conocimiento. LA MARCA EL HORNERO no será
              responsable de ninguna pérdida o robo de información de usuarios
              transmitidos desde o almacenados en un ordenador o dispositivo o
              de las transacciones no autorizadas o fraudulentas relacionadas
              con la Plataforma.
            </p>
            <p className="Terms__paragraph">
              La creación de una cuenta o de optar por recibir notificaciones u
              ofertas no garantiza la recepción de dichos mensajes o la
              disponibilidad de cualquier oferta promocional.
            </p>
            <p className="Terms__paragraph">
              El usuario acepta que los proveedores de LA MARCA EL HORNERO y LA
              MARCA EL HORNERO pueden recopilar y utilizar los datos técnicos y
              la información relacionada, incluyendo pero no limitado a la
              información técnica sobre su dispositivo, geolocalización, fecha y
              hora de la plataforma de acceso, sistema y software de aplicación,
              y periféricos, que se reúne periódicamente para, entre otras
              cosas, facilitarle el suministro de actualizaciones de software,
              soporte de producto y otros servicios en relación con la
              Plataforma. Usted concede a LA MARCA EL HORNERO O A LAS EMPRESAS
              QUE DISTRIBUYEN LA MARCA, el permiso para utilizar esta
              información para mejorar sus productos o para proporcionarle a
              usted servicios o tecnologías, así como para proporcionar
              contenido de la publicidad en la que LA MARCA EL HORNERO cree que
              podría estar interesado, incluyendo el trabajo con terceros que
              proporcionan contenido de publicidad dirigida.
            </p>
            <h2 className="Terms__subtitle">
              TRANSACCIONES Y DISPONIBILIDAD DE LOS PRODUCTOS
            </h2>
            <p className="Terms__paragraph">
              A través de la plataforma, usted puede ser capaz de ordenar y / o
              pagar a LA MARCA EL HORNERO O LAS EMPRESAS QUE DISTRIBUYEN LA
              MARCA por productos o servicios. Para ser capaz de pedir y pagar
              por este tipo de productos o servicios, debe proporcionar cierta
              información relevante para su operación, incluyendo, sin
              limitación, el número de su tarjeta de crédito o de débito, la
              fecha de vencimiento de su tarjeta de crédito o de débito, el
              nombre de su tarjeta de crédito o tarjeta de débito y su dirección
              de facturación. También puede suministrar la información de envío.
              Usted representa y garantiza que tiene el derecho legal de uso de
              cualquier tarjeta bancaria u otro método de pago utilizado en
              conexión con cualquier transacción. Mediante la presentación de
              dicha información, usted otorga a LA MARCA EL HORNERO y / o los
              terceros el derecho de proporcionar y transmitir dicha información
              a los efectos de facilitar la realización de las transacciones
              iniciadas por usted o en su nombre. La verificación de la
              información puede ser requerida antes de la confirmación o la
              realización de cualquier transacción.
            </p>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO puede permitir que, a través de la Plataforma,
              usted solicite elementos del menú u otros productos o servicios
              (colectivamente “Productos o Servicios”) desde su ubicación. Todas
              las descripciones, imágenes, características, especificaciones,
              productos y precios de productos o servicios están sujetos a
              cambios en cualquier momento sin previo aviso. La inclusión de
              cualquier producto o servicio en la Plataforma no implica ni
              garantiza que estos productos o servicios estarán disponibles. LA
              MARCA EL HORNERO O LAS EMPRESAS QUE DISTRIBUYEN LA MARCA se
              reserva el derecho, con o sin previo aviso, de hacer una o más de
              las siguientes acciones por cualquier razón: (i) limitar la
              cantidad disponible o retirar cualquier producto o servicio; (ii)
              imponer condiciones sobre el cumplimiento de cualquier cupón,
              código de cupón, código promocional, u otra promoción similar;
              (iii) impedir que consiga realizar o completar cualquiera o todas
              las transacciones; y (iv) negar a proporcionar cualquier producto
              o servicio. Usted acepta pagar todos los cargos incurridos por
              usted, en su nombre o por su cuenta a través de la Plataforma, al
              precio vigente en el momento de incurrir en tales cargos. Usted es
              el único responsable de cualquier impuesto aplicable a su
              transacción. Usted reconoce y acepta que la web y pedidos móviles
              y la posibilidad de comprar productos y servicios solo están
              disponibles en las ubicaciones participantes (las cuales están
              sujetas a cambios sin previo aviso). Los precios y la
              disponibilidad de elementos de menú y opciones de personalización
              varían según la ubicación.
            </p>
            <p className="Terms__paragraph">
              Cualquier producto o servicio descrito en la plataforma están
              disponibles sólo en jurisdicciones en las que pueden ser
              legalmente ofrecidos para la venta. LA INFORMACIÓN SOBRE LA
              PLATAFORMA NO ES UNA OFERTA O ANUNCIO por cualquier persona en
              cualquier jurisdicción en la que dicha oferta o solicitud no puede
              hacerse legalmente.
            </p>
            <p className="Terms__paragraph">
              Usted entiende y acepta que si su forma de pago es con tarjeta de
              crédito o débito se le cobrará en el momento de realizar su pedido
              de productos o servicios. Usted entiende y acepta que la
              transacción para la compra de productos o servicios es definitiva
              y completa en el momento en que se le cobra. Una vez que se hace
              un pedido, no se pueden realizar cambios a la orden. Una vez que
              LA MARCA EL HORNERO haya aceptado la orden y enviado una
              notificación de dicha aceptación a través de la Plataforma, usted
              no podrá cancelar su pedido. En caso de que usted cancele su
              orden, el pedido será anulado y su reembolso será procesado en
              caso de que su forma de pago haya sido a través de tarjeta de
              débito o crédito. Los reembolsos serán procesados en cualquier
              momento durante las cuatro semanas siguientes a la cancelación del
              pedido; los tiempos de devolución pueden variar en función de su
              emisor de tarjeta de pago. La funcionalidad de pedido de la
              Plataforma está destinada a usuarios fuera del sitio y no se debe
              usar para hacer un pedido desde el interior de cualquiera de los
              restaurantes de LA MARCA EL HORNERO.
            </p>
            <h2 className="Terms__subtitle">DESPACHO Y ENTREGA DE PEDIDOS</h2>
            <p className="Terms__paragraph">
              Una vez que usted haya realizado un pedido y lo haya pagado en
              caso de que su forma de pago haya sido con tarjeta de crédito o
              débito, LA MARCA EL HORNERO O LAS EMPRESAS QUE DISTRIBUYEN LA
              MARCA podrá aceptar o rechazar su orden. En caso de aceptar la
              orden usted será notificado de que su orden está siendo preparada
              y recibirá un tiempo estimado en el cuál su pedido llegará a la
              dirección proporcionada. Este tiempo de entrega es un estimado y
              usted acepta que existen factores ajenos a la operación de LA
              MARCA EL HORNERO que podrían retrasar o aumentar el tiempo de
              entrega del pedido tales como: clima adverso, tráfico, emergencia
              mecánica, accidentes, entre otros. Un pedido no podrá tardar en
              llegar más de noventa minutos, caso contrario LA MARCA EL HORNERO
              O LAS EMPRESAS QUE DISTRIBUYEN LA MARCA se compromete a realizar
              un reembolso del costo del pedido. Si el pago se realizó mediante
              el uso de tarjeta de crédito o de débito, el plazo para el
              reembolso será aquel que maneje cada emisor de tarjeta de crédito
              o débito para el procesamiento de la respectiva devolución. En
              caso de usted haya seleccionado como forma de pago el efectivo,
              usted acepta que debe pagar el monto final de la orden una vez que
              el pedido llegue a la dirección otorgada por usted a través de la
              Plataforma.
            </p>
            <p className="Terms__paragraph">
              En caso de que LA MARCA EL HORNERO rechace el pedido, se le
              notificará la razón por la cual no es posible aceptar la orden.
            </p>
            <h2 className="Terms__subtitle">
              REPRESENTACIÓN, RENUNCIA DE GARANTÍAS Y LIMITACIONES DE
              RESPONSABILIDAD
            </h2>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO y sus subsidiarias, funcionarios, empleados y
              contratistas del sitio web y cada uno de sus funcionarios,
              empleados y agentes (colectivamente, “Afiliados de LA MARCA EL
              HORNERO”) no representan o dan garantía alguna en cuanto a la
              integridad, exactitud, puntualidad o idoneidad de cualquier
              información, datos, puntos de vista, opiniones, declaraciones o
              recomendaciones que figuran en la Plataforma.
            </p>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO y los afiliados de LA MARCA EL HORNERO no son
              responsables de los daños causados al dispositivo de cualquier
              usuario o de daños al ordenador por cualquier virus, errores,
              manipulación, intervención no autorizada, fraude, error, omisión,
              interrupción, supresión, defecto, demora en la operación o
              transmisión, falla en la línea, o cualquier otro fallo técnico u
              error de cualquier tipo. También debe tener en cuenta que el
              correo electrónico y otras comunicaciones a través de Internet
              pueden no ser seguras y usted debe considerar esto antes de enviar
              información por correo electrónico a LA MARCA EL HORNERO y
              Afiliados de LA MARCA EL HORNERO, o antes de publicar en la
              Plataforma. LA MARCA EL HORNERO y los Afiliados de LA MARCA EL
              HORNERO no dan garantía alguna en cuanto a la idoneidad, la
              funcionalidad, el rendimiento, la disponibilidad o el
              funcionamiento de la Plataforma. Esta Plataforma puede estar
              temporalmente fuera de servicio debido a mantenimiento, mal
              funcionamiento de los equipos informáticos, o por otras razones.
            </p>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO no garantiza que las funciones o servicios
              realizados o facilitados a través de la Plataforma (incluyendo
              cualquier actualización de la Plataforma) cumplan con sus
              requisitos, que la operación de la Plataforma y sus
              actualizaciones será ininterrumpida o libre de errores, o que los
              defectos de la Plataforma serán corregidos.
            </p>
            <p className="Terms__paragraph">
              Usted acepta que LA MARCA EL HORNERO y los Afiliados de LA MARCA
              EL HORNERO no son responsables por daños de cualquier tipo, ya sea
              basado en agravio, contrato, responsabilidad objetiva o de otro
              modo, incluyendo, sin limitación, daños directos, especiales,
              indirectos, incidental, o daños punitivos derivados en cualquier
              forma o en relación con: (i) la plataforma, el contenido, y / o
              cualquier MENSAJE; (ii) cualquier error u omisión en la
              manipulación técnica o contenido de la plataforma; (iii) cualquier
              medida adoptada en relación con una investigación por LA MARCA EL
              HORNERO, aplicación de ley, u otras autoridades con respecto a su
              uso de la Plataforma o el Contenido; (iv) cualquier medida
              adoptada en relación con los propietarios de derecho de autor; O
              (v) la conducta, acciones o inacciones de usuarios de la
              plataforma o sus interacciones o relaciones con los usuarios de la
              plataforma, incluso si LA MARCA EL HORNERO o los Afiliados de LA
              MARCA EL HORNERO han sido informados de la posibilidad de tales
              daños, causados en todo o en parte por negligencia, fallo de
              telecomunicaciones, robo, destrucción o acceso no autorizado a la
              Plataforma o su información.
            </p>
            <h2 className="Terms__subtitle">
              ENLACES A LAS PLATAFORMAS Y SERVICIOS DE TERCEROS
            </h2>
            <p className="Terms__paragraph">
              La Plataforma puede proporcionar conectividad o enlaces a otros
              servicios de terceros, sitios web, aplicaciones, software y otros
              contenidos de terceros proveedores como los interlocutores
              sociales, los medios de comunicación, proveedores de servicios
              móviles y desarrolladores de aplicaciones de software de terceros
              ( “Servicios de Terceros “). La Plataforma puede permitirle
              agregar / configurar ciertos servicios de terceros en el
              dispositivo. La Plataforma también le puede permitir que inicie su
              cuenta a través de Facebook u otra cuenta de medios de
              comunicación social. LA MARCA EL HORNERO no tiene ningún control
              sobre esto, no representa o da garantías de ningún tipo acerca de
              cualquiera de los servicios de terceros a los que acceda, no es
              responsable de la disponibilidad de dichos Servicios de terceros,
              y no los respalda ni es responsable de cualquier contenido u otros
              materiales disponibles en dichos Servicios de terceros. Su uso de
              los servicios de terceros puede estar sujeto a términos
              adicionales, incluyendo los términos de licencia de software, de
              dichos terceros.
            </p>
            <p className="Terms__paragraph">
              Si utiliza Servicios de terceros, usted acepta que es consciente
              de que la cuenta y otra información personal en manos de esos
              terceros pueden ser transmitidos a LA MARCA EL HORNERO y se
              almacenan en los servidores de LA MARCA EL HORNERO y / o
              aplicaciones ubicadas en los Estados Unidos y en otros lugares.
              Usted entiende y acepta que las empresas que prestan los servicios
              de terceros pueden acceder, utilizar y compartir cierta
              información sobre usted. Usted entiende y acepta que LA MARCA EL
              HORNERO no es responsable de estas empresas, o el uso de su
              información. El uso de los servicios de terceros es bajo su propio
              riesgo.
            </p>
            <h2 className="Terms__subtitle">ASIGNACIÓN</h2>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO puede ceder este contrato, en su totalidad o
              en parte, en cualquier momento con o sin previo aviso. Usted no
              puede ceder este contrato, o cualquier parte de ella, a cualquier
              otra persona. Cualquier intento por su parte de hacerlo es nulo.
              Usted no puede transferir a cualquier otra persona, ya sea
              temporal o permanentemente, cualquier derecho a utilizar la
              totalidad o parte de la Plataforma. En la medida en que permite
              que un tercero utilice su dispositivo, usted que será el único
              responsable del uso de la Plataforma por las demás personas que
              utilicen el dispositivo.
            </p>
            <h2 className="Terms__subtitle">GENERAL</h2>
            <p className="Terms__paragraph">
              AL ACCEDER a esta Plataforma y / o aceptar la información de esta
              Plataforma, usted acepta indemnizar, defender y mantener a LA
              MARCA EL HORNERO y los Afiliados de LA MARCA EL HORNERO ilesos de
              y contra cualquier reclamación real o presunta, demandas, causas
              de acción , juicios, daños, pérdidas, responsabilidades y todos
              los costos y gastos de defensa (incluyendo honorarios legales
              razonables y costos judiciales) derivados de o en relación a: (A)
              el incumplimiento de este Acuerdo por parte de usted; (B) la
              violación de normas o reglamentos locales, estatales, federales o
              de derecho internacional por parte de usted; (C) las alegaciones
              de un tercero que se basan en el uso de la Plataforma o el
              Contenido por parte de usted; (D) la información o material
              incluido o transmitido a través del dispositivo, computadora, o
              cuenta, aunque no sea presentada por usted; (E) cualquier
              tergiversación realizada por usted; (F) cualquier disputa entre
              usted y otro usuario de la plataforma; (G) del robo, apropiación
              indebida o la divulgación de su contraseña u otros datos de su
              cuenta; (H) su autorización de que alguien más use su contraseña.
              Usted cooperará tanto como sea razonablemente requerido en defensa
              de LA MARCA EL HORNERO en cualquier demanda. LA MARCA EL HORNERO O
              LAS EMPRESAS QUE DISTRIBUYEN LA MARCA, se reservan el derecho, a
              su propio costo, de asumir la defensa exclusiva y control de
              cualquier asunto sujeto a indemnización por usted, y usted no
              podrá, en cualquier caso, resolver cualquier asunto sin el
              consentimiento por escrito de LA MARCA EL HORNERO.
            </p>
            <p className="Terms__paragraph">
              Si alguna disposición de este Acuerdo es considerada inválida por
              cualquier ley, regla, orden o regulación de cualquier gobierno o
              por la determinación final de cualquier corte estatal o federal,
              dicha invalidez no afectará a la aplicabilidad de cualquier otra
              disposición de este Acuerdo. En el caso de que cualquier
              disposición de este Acuerdo sea ilegal o no ejecutable, dicha
              disposición será separada, y el resto del Acuerdo continuará en
              pleno vigor y efecto. El fracaso de LA MARCA EL HORNERO para
              ejercer o hacer valer cualquier derecho o disposición de este
              Acuerdo no constituirá una renuncia a tal derecho o disposición.
            </p>
            <p className="Terms__paragraph">
              Mediante el uso de la plataforma, el usuario acepta que los
              estatutos y leyes del Ecuador, sin tener en cuenta conflictos de
              principios legales, se aplicarán a todos los asuntos relacionados
              con el uso de la Plataforma y de los Servicios, y usted acepta que
              cualquier litigio estará sujeto a la jurisdicción exclusiva de los
              tribunales nacionales. La Convención de las Naciones Unidas sobre
              los contratos de compraventa internacional de mercaderías (1980)
              queda excluida en su totalidad de la aplicación del presente
              Acuerdo.
            </p>
            <p className="Terms__paragraph">
              Usted acepta que independientemente de cualquier estatuto o ley,
              cualquier reclamación o causa de acción que surja de o esté
              relacionada con el uso de la Plataforma o este Acuerdo debe ser
              presentada dentro de un (1) mes después de dicho reclamo o causa
              de acción o se cerrará para siempre. Además, acepta que cualquier
              disputa, reclamación y causas de acción que surja de o en conexión
              con la Plataforma y / o el presente contrato se resolverán
              individualmente, sin recurrir a ninguna forma de demanda
              colectiva.
            </p>
            <p className="Terms__paragraph">
              Usted reconoce y acepta que el uso de la Plataforma puede implicar
              que proporcione una “firma electrónica”, indicando su deseo de
              utilizar la plataforma. Su “firma electrónica” indica su
              aceptación de este Acuerdo, y su consentimiento para recibir
              comunicaciones sobre este Acuerdo electrónicamente. Si desea
              recibir comunicaciones de otra manera, puede comunicarse con EL
              HORNERO en clientes@elhornero.com.ec para cambiar sus preferencias
              de comunicación. Usted no puede utilizar, ni tampoco exportar o
              reexportar la Plataforma salvo excepción autorizada por la ley de
              Ecuador y las leyes de la jurisdicción en la que se obtuvo la
              Plataforma.
            </p>
            <p className="Terms__paragraph">
              En el caso de una queja o preocupación con respecto a este Acuerdo
              o la plataforma, o para más información, póngase en contacto con
              PIZZERIA EL HORNERO{" "}
              <a
                className="Terms__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://pizzeriaelhornero.com.ec/contactos/"
              >
                aquí
              </a>
              .
            </p>
            <p className="Terms__paragraph">
              Tanto usted como EL HORNERO reconoce y acepta que ninguna
              asociación está formada y ninguno de los dos ni LA MARCA EL
              HORNERO tiene el poder o la autoridad para obligar o vincular a la
              otra. En ciertas áreas de la Plataforma, se le puede dar la
              capacidad de proporcionar información de identificación personal.
              Por favor, lea con atención la Política de Privacidad de LA MARCA
              EL HORNERO; para obtener más información acerca de las prácticas
              de recopilación y uso de LA MARCA EL HORNERO. El fracaso de LA
              MARCA EL HORNERO a cumplir con este Acuerdo a causa de un acto
              natural, guerra, incendio, motín, terrorismo, terremotos, las
              acciones de los gobiernos federales, estatales, territoriales, o
              las autoridades gubernamentales locales, o por cualquier otra
              causa más allá del control razonable de LA MARCA EL HORNERO, no se
              considerará un incumplimiento de este Acuerdo.
            </p>
            <p className="Terms__paragraph">
              Si este Acuerdo o su permiso para usar la plataforma se termina
              por LA MARCA EL HORNERO por cualquier motivo, los términos de este
              Acuerdo, no obstante, seguirán siendo aplicables y serán
              vinculantes para usted con respecto a su uso previo de ésta
              Plataforma y todo lo relacionado con o que surjan de tal uso. Si
              no está satisfecho con esta Plataforma o con este Acuerdo o la
              política de privacidad, a continuación, su único y exclusivo
              remedio es dejar de usar estas plataformas.
            </p>
            <h2 className="Terms__subtitle">
              TÉRMINOS ADICIONALES PARA USUARIOS DE LA PLATAFORMA DE APLICACIÓN
              MÓVIL
            </h2>
            <p className="Terms__paragraph">
              El uso de la plataforma en su aplicación móvil da consentimiento
              expreso para recibir notificaciones push desde y en nombre de LA
              MARCA EL HORNERO.
            </p>
            <h2 className="Terms__subtitle">
              Usuarios de la plataforma móvil de Apple
            </h2>
            <p className="Terms__paragraph">
              Si descarga y / o utiliza la plataforma en iPhone o iPad: Usted,
              el usuario final de esta Plataforma, reconoce que se introduce
              este acuerdo por y entre LA MARCA EL HORNERO y usted y no con
              Apple, Inc., y Apple, Inc. no es responsable de la Plataforma y /
              o su contenido. No obstante lo anterior, usted reconoce que Apple,
              Inc. y sus subsidiarias son terceros beneficiarios de este acuerdo
              y que Apple, Inc. tiene el derecho (y se considerará que ha
              aceptado el derecho) para hacer cumplir este acuerdo. Usted
              reconoce que Apple, Inc. no tiene obligación alguna de mantener o
              apoyar la Plataforma. Usted reconoce que ha revisado los términos
              y condiciones (situados en línea{" "}
              <a
                className="Terms__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.apple.com/legal/internet-services/itunes/us/terms.html#APPS"
              >
                aquí
              </a>
              ) App Store. Este acuerdo incorpora por referencia al Acuerdo de
              Licencia Plataforma licencia de usuario final (el “LAEULA”)
              publicado por Apple, Inc. (que se encuentra en línea{" "}
              <a
                className="Terms__link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
              >
                aquí
              </a>
              ). Para efectos del presente Acuerdo, la Plataforma se considera
              la “Plataforma de licencia” tal como se define en el LAEULA y LA
              MARCA EL HORNERO es considerado como el “proveedor de la
              plataforma” tal como se define en el LAEULA. Si cualquier término
              de este Acuerdo entra en conflicto con los términos de la LAEULA,
              los términos de este acuerdo prevalecerán. Además, usted reconoce
              y acepta que en ningún caso Apple, Inc. será responsable de
              cualquier reclamación relacionada con la Plataforma (incluyendo,
              sin limitación, una reclamación de terceros de que la Plataforma
              infringe los derechos de propiedad intelectual de dichos terceros)
              o su uso o posesión de la Plataforma, incluyendo pero no limitado
              a: (i) las demandas de responsabilidad de productos; (ii)
              cualquier reclamación que la Plataforma no cumple con todos los
              requisitos legales o reglamentarias aplicables; y (iii) las
              alegaciones basadas en la protección del consumidor o legislación
              similar. Usted reconoce y acepta que, en la medida máxima
              permitida por la ley aplicable, Apple, Inc. no tendrá ninguna
              obligación de garantía alguna con respecto a la Plataforma.
            </p>
            <h2 className="Terms__subtitle">
              Actualizaciones de la aplicación móvil
            </h2>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO puede poner a disposición para descargar
              ciertos cambios o actualizaciones de la Plataforma para
              actualizar, mejorar o desarrollar aún más la plataforma
              (“Actualizaciones de la Plataforma”). La presente licencia le
              permite descargar y utilizar las actualizaciones de la Plataforma
              para actualizar la misma en cualquier dispositivo que posea o
              controle. Este Acuerdo no le permite actualizar los dispositivos
              que no posee o controla, y usted no puede hacer que las
              actualizaciones de la Plataforma estén disponibles a través de una
              red en donde pueda ser utilizado por varios dispositivos o varios
              equipos al mismo tiempo. No está permitido hacer copias de las
              actualizaciones de la Plataforma, a menos que dicha copia está
              autorizada por escrito por LA MARCA EL HORNERO.
            </p>
            <p className="Terms__paragraph">
              Salvo y sólo en la medida permitida por la ley aplicable, o de las
              condiciones de licencia que rigen el uso de componentes de código
              abierto incluidos en la Plataforma, usted no puede copiar,
              descompilar, realizar ingeniería inversa, desmontar o intentar
              obtener el código fuente, modificar, o crear trabajos derivados de
              la Plataforma, las actualizaciones de Plataforma, o parte de ella.
              Cualquier intento de hacerlo es una violación de los derechos que
              posee la marca EL HORNERO y sus proveedores de licencias de la
              Plataforma y las actualizaciones de Plataforma. Mediante el
              almacenamiento de contenido en el dispositivo, usted está haciendo
              una copia digital. En algunas jurisdicciones, es ilegal hacer
              copias digitales sin la autorización previa del titular de los
              derechos. La Plataforma y las actualizaciones de Plataforma se
              pueden utilizar para reproducir materiales, siempre que dicho uso
              se limite a la reproducción de los materiales sin derechos de
              autor, materiales sobre los cuales usted posea los derechos de
              autor o materiales que está legalmente autorizado a reproducir.
            </p>
            <p className="Terms__paragraph">
              LA MARCA EL HORNERO puede, a su discreción, subir automáticamente
              las actualizaciones de Plataforma en el dispositivo. Usted se
              compromete a aceptar estas actualizaciones de Plataforma y pagar
              por los costos asociados con su recepción. La Plataforma y sus
              actualizaciones están sujetas a las leyes y regulaciones de
              exportación de Ecuador. Usted debe cumplir con todas las leyes de
              exportación nacionales e internacionales y reglamentos que se
              aplican a la Plataforma y las actualizaciones de la Plataforma.
              Estas leyes incluyen restricciones sobre destinos, usuarios
              finales y uso final.
            </p>
          </div>
        </section>
      </main>
      <footer className="Terms__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

Terms.defaultProps = {};

export default Terms;
